const TransactionList = ({ transactions, toggle, getTransactionId }) => {
  return (
    <ul className="list">
      {transactions.map((transaction) => (
        <li
          key={transaction._id}
          className={transaction.type === 'income' ? 'plus' : 'minus'}
          onClick={() => {
            toggle();
            getTransactionId(transaction._id);
          }}
        >
          {transaction.description}
          <span>{transaction.amount.toLocaleString('ro-RO')}</span>
        </li>
      ))}
    </ul>
  );
};

export default TransactionList;
